<template>
  <v-toolbar app>
    <v-toolbar-side-icon class="hidden-sm-and-up"></v-toolbar-side-icon>
    <v-toolbar-title>{{$route.name}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat @click="logout()">Logout</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  methods: {
    ...mapActions([
      'clearUserToken'
    ]),
    logout: function (){
      this.clearUserToken().then(() => {
        this.$router.push({'name':'Auth'})
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
